EventEmitter = require 'eventemitter3'

class Modal extends EventEmitter
  constructor: (target)->
    @init(target)

  init: (target)->
    @$body = $(document.body)
    @$overlay
    @$modal = $(target)
    @$dialog = @$modal.find('.modal_dialog')
    @setOverlay();

  setOverlay: ->
    $overlay = $('<div>').addClass('modalOverlay')
    @$body.append($overlay)
    @$overlay = $overlay

  show: =>
    self = @
    @$overlay.show()
    @$modal.css('opacity', 0).show()
    setTimeout ->
      self.adjustDialog()
      self.$modal.css('opacity', 1)
    , 100
    $(window).on('resize.modal', => @adjustDialog())

  hide: =>
    @$overlay.hide()
    @$modal.hide()
    $(window).off('resize.modal')

  adjustDialog: =>
    dialogHeight = @$dialog.height()
    windowHeight = $(window).height()
    adjustPosition = (windowHeight - dialogHeight) / 2 - 20 #(事前に設定しているmargin-top分を引く)
    adjustPosition = 0 if adjustPosition < 0
    @$dialog.css('top', adjustPosition)

module.exports = Modal


// WEBPACK FOOTER //
// ./src/scripts/modules/Modal.coffee